import { useState } from "react"
import type { PostMediaItem } from "../../types/analytics"

interface Props {
  items: PostMediaItem[]
}

const PostMediaPlayer = ({ items }: Props) => {
  const [index, setIndex] = useState(0)

  if (items.length === 0) {
    return <div className="post-media-player__empty"><i className="bi bi-image" /></div>
  }

  const current = items[index]
  const isVideo = current.media_type === "VIDEO"

  return (
    <div className="post-media-player">
      <div className="post-media-player__stage">
        {isVideo ? (
          <video
            key={current.url}
            src={current.url}
            controls
            className="post-media-player__media"
          />
        ) : (
          <img
            src={current.url}
            alt=""
            className="post-media-player__media"
          />
        )}

        {items.length > 1 && (
          <>
            <button
              className="post-media-player__arrow post-media-player__arrow--prev"
              onClick={() => setIndex(i => i - 1)}
              disabled={index === 0}
              aria-label="前へ"
            >
              <i className="bi bi-chevron-left" />
            </button>
            <button
              className="post-media-player__arrow post-media-player__arrow--next"
              onClick={() => setIndex(i => i + 1)}
              disabled={index === items.length - 1}
              aria-label="次へ"
            >
              <i className="bi bi-chevron-right" />
            </button>
          </>
        )}
      </div>

      {items.length > 1 && (
        <div className="post-media-player__dots">
          {items.map((_, i) => (
            <button
              key={i}
              className={`post-media-player__dot${i === index ? " post-media-player__dot--active" : ""}`}
              onClick={() => setIndex(i)}
              aria-label={`${i + 1}枚目`}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default PostMediaPlayer
